import { ITableTitle } from "./../../../../types/table"

export const SHomeTitles: ITableTitle[] = [
  { type: "header", slug: "fullname" },
  { type: "header", slug: "login" },
  { type: "header", slug: "role" },
  { type: "header", slug: "updatedAt" },
  { type: "header", slug: "createdAt" },
]
